import React from 'react';
import { Button, Spin } from 'antd';
import { CloseOutlined, DeleteOutlined, CheckOutlined, LoadingOutlined } from '@ant-design/icons';

const SelectedTrafficCard = ({
  selectedTraffic,
  setSelectedTraffic,
  setFormValues,
  setIsFromMap,
  showModal,
  visible = true,
  setVisible,
  isLoadingTermina = false,
  setIsLoadingTermina,
  setManualSelect
}) => {
  if (selectedTraffic.length === 0 || !visible) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '180px',
        left: '20px',
        width: '320px',
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
        zIndex: 1004,
        overflow: 'hidden'
      }}
    >
      {/* Card Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 20px',
        borderBottom: '1px solid #f0f0f0',
        background: 'linear-gradient(135deg, #fafafa 0%, #ffffff 100%)'
      }}>
        <div style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#1a1a1a'
        }}>
          Selezionati {selectedTraffic.length} semafori
        </div>
        <Button
          type="text"
          icon={<CloseOutlined style={{ color: '#999', fontSize: '14px' }} />}
          onClick={() => setSelectedTraffic([])}
          style={{
            padding: 0,
            width: 24,
            height: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        />
      </div>

      {/* Card Body */}
      <div style={{
        padding: '16px 20px',
        maxHeight: '240px',
        overflowY: 'auto'
      }}>
        {selectedTraffic.map((traffic, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '10px 0',
              borderBottom: index < selectedTraffic.length - 1 ? '1px solid #f5f5f5' : 'none'
            }}
          >
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #A1E430 0%, #8FD420 100%)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 13,
                fontWeight: 'bold',
                flexShrink: 0
              }}
            >
              {index + 1}
            </div>
            <span style={{
              flex: 1,
              fontSize: '14px',
              color: '#333',
              fontWeight: '500'
            }}>
              {traffic.nome || traffic.name || traffic.id || `${traffic.id}`}
            </span>
            <Button
              type="text"
              icon={<DeleteOutlined style={{ color: '#ff4444', fontSize: '14px' }} />}
              onClick={() => {
                const newSelected = [...selectedTraffic];
                newSelected.splice(index, 1);
                setSelectedTraffic(newSelected);
              }}
              style={{
                padding: '4px',
                width: 28,
                height: 28,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            />
          </div>
        ))}
      </div>

      {/* Card Footer */}
      <div style={{
        display: 'flex',
        gap: 12,
        padding: '16px 20px',
        borderTop: '1px solid #f0f0f0',
        background: 'linear-gradient(135deg, #fafafa 0%, #ffffff 100%)'
      }}>
        <Button
          onClick={() => setSelectedTraffic([])}
          style={{
            flex: 1,
            height: '40px',
            borderRadius: '20px',
            border: '1px solid #ff4444',
            background: 'white',
            color: '#ff4444',
            fontWeight: '500',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px'
          }}
        >
          <CloseOutlined style={{ fontSize: '14px' }} />
          Deseleziona
        </Button>
        <Button
          onClick={() => {
            if (selectedTraffic.length > 0) {
              if (setIsLoadingTermina) setIsLoadingTermina(true);
              setFormValues(prev => ({
                ...prev,
                semafori: selectedTraffic.map((t, i) => ({
                  id: t.id || `s${i + 1}`,
                  nome: t.nome || t.name || `S${i + 1}`,
                  distanza: t.distanza || 100,
                  durata_verde: t.durata_verde || 20,
                  lunghezza_attraversamento: t.lunghezza_attraversamento || 10
                }))
              }));
              setIsFromMap(true);
              showModal();
              // Stop selection mode and close the card after a short delay
              if (setManualSelect) setManualSelect(false);
              setTimeout(() => {
                if (setVisible) setVisible(false);
                if (setIsLoadingTermina) setIsLoadingTermina(false);
              }, 300);
            }
          }}
          disabled={isLoadingTermina}
          style={{
            flex: 1,
            height: '40px',
            borderRadius: '20px',
            background: isLoadingTermina
              ? '#d9d9d9'
              : 'linear-gradient(135deg, #A1E430 0%, #8FD420 100%)',
            border: 'none',
            color: '#1a1a1a',
            fontWeight: '600',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px'
          }}
        >
          {isLoadingTermina ? (
            <LoadingOutlined style={{ fontSize: '14px' }} spin />
          ) : (
            <CheckOutlined style={{ fontSize: '14px' }} />
          )}
          {isLoadingTermina ? 'Caricamento...' : 'Termina'}
        </Button>
      </div>
    </div>
  );
};

export default SelectedTrafficCard;